/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PointsStrictHttpResponse } from '../../points-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentBalanceModel } from '../../models/current-balance-model';

export interface ConsumerCurrentBalanceGet$Params {
}

export function consumerCurrentBalanceGet(http: HttpClient, rootUrl: string, params?: ConsumerCurrentBalanceGet$Params, context?: HttpContext): Observable<PointsStrictHttpResponse<CurrentBalanceModel>> {
  const rb = new RequestBuilder(rootUrl, consumerCurrentBalanceGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PointsStrictHttpResponse<CurrentBalanceModel>;
    })
  );
}

consumerCurrentBalanceGet.PATH = '/Consumer/CurrentBalance';
